module.exports = __webpack_public_path__ + "static/media/steve-job.806e298f.webp";